import React, { useState, useMemo, useEffect, useContext } from 'react';
import { StyledLinkWalletContainer } from './LinkWallet.styled';
import Profile from '../Header/Profile';
import { PlayerContext } from '../../contexts/playerContext';

const LinkWallet = () => {
    const playerContext = useContext(PlayerContext);

    const handleConnectWallet = () => {
        playerContext?.handleConnectWallet();
    }

    const handleDisConnectWallet = async () => {
        await playerContext?.wallet.disconnect();
    }

    return (
        <StyledLinkWalletContainer>
            {
                !playerContext?.wallet.connected ? (
                    <div onClick={handleConnectWallet}>Link Wallet</div>
                )
                    :
                    (
                        <Profile balance={playerContext.tokenBalance} handleDisConnectWallet={handleDisConnectWallet} />
                    )
            }

        </StyledLinkWalletContainer>
    );
}

export default LinkWallet;
